import { render } from "./ActGoal4.vue?vue&type=template&id=3f3276c2"
import script from "./ActGoal4.vue?vue&type=script&lang=js"
export * from "./ActGoal4.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__